
import { Dialog } from "element-ui"
export default {
  name: "CouponUsageRules",
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ruleTitle: {
      type: String,
      default: ""
    },
    ruleContent: {
      type: String,
      default: ""
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curVisible: this.visible
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
    }
  },
  methods: {
    handleClose() {
      this.$emit("close")
    }
  }
}
